import { useState } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import WhatIsKuze from './components/WhatIsKuze';
import Games from './components/Games';
import HowItWorks from './components/HowItWorks';
import Packs from './components/Packs';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="bg-[#0a0a0f] text-white min-h-screen">
      <Navigation mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <Hero />
      <WhatIsKuze />
      <Games />
      <HowItWorks />
      <Packs />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
